import { useCallback, useState } from "react";

import type { Question, QuizData } from "@ui/components/SobQuiz/SobQuiz.types";

export const useQuizProgress = (quizData: QuizData) => {
  const [currentQuestion, setCurrentQuestion] = useState<Question | null>(null);
  const [currentStep, setCurrentStep] = useState(1);

  const findNextQuestion = useCallback(
    (answerId?: string) => {
      return quizData.quizTransitions.find(({ onAnswerId }) => {
        if (answerId) return onAnswerId === answerId;
        return !onAnswerId;
      });
    },
    [quizData.quizTransitions]
  );

  const progressToNextQuestion = useCallback(
    (answerId?: string) => {
      const nextQuestion = findNextQuestion(answerId);
      if (nextQuestion) {
        setCurrentStep((prev) => prev + 1);
        setCurrentQuestion(nextQuestion);
        return true;
      }
      return false;
    },
    [findNextQuestion]
  );

  const initializeProgress = useCallback(
    (previousAnswerId?: string, previousStep?: number) => {
      const firstQuestion = findNextQuestion(previousAnswerId);
      setCurrentQuestion(firstQuestion || null);
      setCurrentStep(previousStep ? previousStep : 1);
    },
    [findNextQuestion]
  );

  return {
    currentQuestion,
    currentStep,
    findNextQuestion,
    progressToNextQuestion,
    initializeProgress,
  };
};
